import * as React from "react";
export class LeagueLabel extends React.PureComponent {
    render() {
        return (React.createElement("div", { className: this.props.className, "data-uat": "div-league-label" }, this.props.text));
    }
}
//# sourceMappingURL=LiveStreamLabel.js.map